import { render, staticRenderFns } from "./Acabados.vue?vue&type=template&id=7472c6ee&scoped=true"
import script from "./Acabados.vue?vue&type=script&lang=js"
export * from "./Acabados.vue?vue&type=script&lang=js"
import style0 from "./Acabados.vue?vue&type=style&index=0&id=7472c6ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7472c6ee",
  null
  
)

export default component.exports